import { updateCapitalOneCreditCardTransactionReceipt } from '../../../graphql/custom_mutations';
import PropTypes from 'prop-types';
import { generateClient } from "aws-amplify/api";

const client = generateClient();

export const updateCreditCardTransactionReceipt = async (props) => {
  if (!props) return;

  try {
    const gqlParams = {
      input: props,
    };

    console.log(' !!! gqlParams: ', gqlParams);

    const response = await client.graphql({
      query: updateCapitalOneCreditCardTransactionReceipt,
      variables: gqlParams,
    });

    console.log(' !!! updateCapitalOneCreditCardTransactionReceipt response: ', response);

    // Amplify can RESOLVE (not throw) with data AND a partial errors array for
    // field-level failures. Surface those so a partial write can't look clean.
    if (response?.errors?.length) {
      console.error(
        '⚠️ updateCapitalOneCreditCardTransactionReceipt returned PARTIAL errors (data still returned):',
        JSON.stringify(response.errors, null, 2)
      );
    }

    const results = response.data.updateSpkCapitalOneCreditCardTransactionReceiptTbl.id;

    console.log(' !!! updateCapitalOneCreditCardTransactionReceipt results: ', results);
    return results;
  } catch (err) {
    // Log the full GraphQL error detail (message / errorType / path) so a
    // failed write can be diagnosed instead of vanishing.
    console.error('❌ updateCapitalOneCreditCardTransactionReceipt FAILED:', {
      message: err?.message,
      errors: err?.errors,
      raw: err,
    });
    return err;
  }
};

updateCreditCardTransactionReceipt.propTypes = {
  props: PropTypes.shape({
    allSort: PropTypes.string,
    id: PropTypes.string.isRequired,
    matchStatus: PropTypes.string,
    capitalOneInstantNotificationId: PropTypes.string,
    plaidCreditCardTransactionId: PropTypes.string,
    qbTransactionEntityId: PropTypes.string,
    isReceiptUploaded: PropTypes.bool,
    quickbooksExpenseId: PropTypes.string,
    clientId: PropTypes.string,
    teamMemberId: PropTypes.string,
    divisionId: PropTypes.string,
    iftaFuelTaxTrackId: PropTypes.string,
    expenseCategoryId: PropTypes.string,
    unitId: PropTypes.string,
    addedNotes: PropTypes.string,
    hasIssue: PropTypes.bool,
    issue: PropTypes.string,
  }).isRequired,
};
